export const NO_FILTER_RESULTS =
  'No results found. Try adjusting your search or filter options.'

export const MY_CONTENT_SEARCH_ROUTES = [
  `fish-my-content-created`,
  `all-markups-card-fish`,
  `markup-type-list-card-tracks-fish`,
  `markup-type-list-card-routes-fish`,
  `markup-type-list-card-waypoints-fish`,
  `markup-type-list-card-lines-fish`,
  `markup-type-list-card-areas-fish`,
  `content-select-unspecified-collection-fish`,
]

export const MY_CONTENT_SEARCH_PERSIST_ROUTES = [
  `content-select-unspecified-collection-fish`,
  `filter-content-fish`,
]
